export default function nafPeople() {
  const buttons = document.querySelectorAll('.naf-people__load-more');
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const termID = btn.dataset.term;
      const offset = parseInt(btn.dataset.offset);
      const section = document.querySelector(`#naf-level-${termID} .naf-people__grid`);

      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const response = await fetch(window.wpData.ajaxUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            action: 'naf_load_more_people',
            term_id: termID,
            offset: offset,
          }),
        });

        const result = await response.json();

        if (result.success && result.data.html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = result.data.html.trim();

          const newCards = tempDiv.children;
          Array.from(newCards).forEach((card, i) => {
            card.setAttribute('data-aos', 'fade-up');
            card.setAttribute('data-aos-delay', `${i * 100}`);
            section.appendChild(card);
          });

          if (typeof AOS !== 'undefined') {
            AOS.refreshHard();
          }

          // ✅ Update offset based on server-provided next_offset
          const newOffset = parseInt(result.data.next_offset);
          const total = parseInt(result.data.total_posts);

          btn.dataset.offset = newOffset;

          console.log(`Loaded offset ${offset} → ${newOffset} of ${total}`);

          // ✅ Hide button only when we've reached or passed the total
          if (newOffset >= total) {
            btn.style.display = 'none';
          } else {
            btn.textContent = 'Load More';
            btn.disabled = false;
          }
        } else {
          btn.style.display = 'none';
        }
      } catch (err) {
        console.error('Load More Error:', err);
        btn.textContent = 'Error';
      }
    });
  });
}
